// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module--header--18yCy","subtitle":"styles-module--subtitle--2ScOu","logo":"styles-module--logo--1hIst"};